import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";
import { Star, Check, X, Trash2 } from "lucide-react";

export default function AdminRecensioni() {
  const [reviews, setReviews] = useState([]);
  const load = () => api.get("/admin/reviews").then((r) => setReviews(r.data));
  useEffect(() => { load(); }, []);

  const moderate = async (id, approved) => {
    await api.put(`/admin/reviews/${id}`, { approved });
    toast.success(approved ? "Recensione approvata" : "Recensione nascosta");
    load();
  };
  const del = async (id) => {
    if (!confirm("Eliminare la recensione?")) return;
    await api.delete(`/admin/reviews/${id}`);
    toast.success("Eliminata");
    load();
  };

  return (
    <div data-testid="admin-recensioni" className="p-10">
      <h1 className="font-serif text-4xl text-white mb-2">Recensioni</h1>
      <p className="text-white/50 text-sm mb-10">Approva, nascondi o elimina le recensioni dei clienti.</p>

      <div className="space-y-4">
        {reviews.map((r) => (
          <div key={r.id} className="luxe-card p-6">
            <div className="flex justify-between items-start gap-4">
              <div className="flex-1">
                <div className="flex items-center gap-3 mb-2">
                  <div className="font-serif text-lg text-white">{r.name}</div>
                  <span className="text-xs text-white/40">{r.city}</span>
                  <span className={`text-xs px-2 py-0.5 rounded-sm ${r.approved ? "bg-[var(--gold)]/15 text-[var(--gold)]" : "bg-white/10 text-white/60"}`}>
                    {r.approved ? "Pubblicata" : "In attesa"}
                  </span>
                </div>
                <div className="flex gap-1 mb-3">
                  {[...Array(r.rating)].map((_, i) => <Star key={i} size={12} fill="#D4AF37" className="text-[var(--gold)]" />)}
                </div>
                <p className="text-sm text-white/70 italic">"{r.text}"</p>
              </div>
              <div className="flex gap-2 shrink-0">
                {!r.approved && (
                  <button data-testid={`review-approve-${r.id}`} onClick={() => moderate(r.id, true)} className="p-2 border border-[var(--gold)]/40 text-[var(--gold)] hover:bg-[var(--gold)]/10"><Check size={14} /></button>
                )}
                {r.approved && (
                  <button onClick={() => moderate(r.id, false)} className="p-2 border border-white/20 text-white/60 hover:bg-white/5"><X size={14} /></button>
                )}
                <button data-testid={`review-delete-${r.id}`} onClick={() => del(r.id)} className="p-2 border border-red-500/30 text-red-400 hover:bg-red-500/10"><Trash2 size={14} /></button>
              </div>
            </div>
          </div>
        ))}
        {!reviews.length && <div className="text-white/40">Nessuna recensione ancora.</div>}
      </div>
    </div>
  );
}
